import styled from 'styled-components';
import { DefaultButton } from '../../styles/globals';
import { IThemeProvider } from '../../styles/theme';

export const DownloadButton = styled(DefaultButton)`
  border-radius: 8px;
  width: auto;
  display: flex;
  align-items: center;
  ${({ theme }: IThemeProvider) => `
    padding: 0 ${theme.layout.spacing.centy};
    background: ${theme.colors.neutral.primary[0]};
    color: ${theme.colors.primary[100]};
    border: 2px solid ${theme.colors.primary[100]};
  `}
`;

export const IconCont = styled.div`
  width: 20px;
  height: 20px;

  ${({ theme }: IThemeProvider) => `
    margin: 0 ${theme.layout.spacing.mikro} 0 0;

    svg {
      height: 13.33px;

      path {
        fill: ${theme.colors.primary[100]};
      }
    }
  `}
`;

export const DownloadButtonCont = styled.div`
  position: absolute;
  top: 0;
  right: 24px;
  z-index: 1000;
`;
